/**
 * state.js
 * Application state management
 */

// Application State
export const state = {
  apiKey: null,  // No longer user-configurable
  chats: JSON.parse(localStorage.getItem("chatbot_chats") || "[]"),
  currentChatId: localStorage.getItem("chatbot_current_chat") || null,
  theme:
    localStorage.getItem("chatbot_theme") ||
    (window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light"),
  selectedTheme:
    localStorage.getItem("chatbot_selected_theme") || "noir",
  sidebarExpanded:
    localStorage.getItem("chatbot_sidebar_state") !== "collapsed",
  isGenerating: false,
  controller: null,
  model: localStorage.getItem("chatbot_model") || "clawdbot",
  selectedAgent: localStorage.getItem("chatbot_agent") || "main",
  attachedFiles: [],
  newMessageCount: 0,
  isReading: false,
  draftTimeout: null,
  showScrollButton: false,
  selectionMode: false,
  selectedMessages: new Set(),
  voiceMode: false,
  isSpeaking: false,
};
